import React from "react";

function Header() {
  return (
    <div className="bg-[#0e1515] border-b border-white/10">
      <div className="flex flex-row justify-start text-white items-center text-center font-bolder text-2xl p-4">
        <p>Albion</p>
      </div>
    </div>
  );
}

export default Header;
